import { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useSchoolReportsUIContext } from "../SchoolReportsUIContext";
import { CustomSelect, ReportStatusOptions, TermFilter } from "../../../../../../_helpers/Helpers";

const prepareFilter = (queryParams, values) => {
  const { term, name, startDate, endDate, plannedPrintDate, reportStatus, printDate } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name, startDate, endDate, plannedPrintDate, reportStatus, printDate };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function SchoolReportsFilter() {
  // School Reports UI Context
  const schoolReportsUIContext = useSchoolReportsUIContext();
  const schoolReportsUIProps = useMemo(() => {
    return {
      setQueryParams: schoolReportsUIContext.setQueryParams,
      queryParams: schoolReportsUIContext.queryParams,
    };
  }, [schoolReportsUIContext]);

  const { currentActiveTerm } = useSelector(
    (state) => ({ currentActiveTerm: state.auth.user.currentActiveTerm }),
    shallowEqual
  );
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(schoolReportsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, schoolReportsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      schoolReportsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        name: "",
        startDate: "",
        endDate: "",
        plannedPrintDate: "",
        printDate: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Karne Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Karne Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="startDate"
                placeholder="Başlangıç Tarihi"
                onBlur={handleBlur}
                value={values.startDate}
                onChange={(e) => {
                  setFieldValue("startDate", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Başlangıç Tarihi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="endDate"
                placeholder="Bitiş Tarihi"
                onBlur={handleBlur}
                value={values.endDate}
                onChange={(e) => {
                  setFieldValue("endDate", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Bitiş Tarihi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="plannedPrintDate"
                placeholder="Planlanan Basım Tarihi"
                onBlur={handleBlur}
                value={values.plannedPrintDate}
                onChange={(e) => {
                  setFieldValue("plannedPrintDate", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Planlanan Basım Tarihi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={ReportStatusOptions}
                value={values.reportStatus}
                placeholder="Durum"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("reportStatus", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Durum</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="printDate"
                placeholder="Basım Tarihi"
                onBlur={handleBlur}
                value={values.printDate}
                onChange={(e) => {
                  setFieldValue("printDate", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Basım Tarihi</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}